import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {brightBlackStyle} from "./GlobalStyles/colors";

function ModalExplain() {
    return (
        <div
            className="modal show"
            style={{ display: 'block', position: 'absolute' , backgroundColor: brightBlackStyle, borderRadius: 7}}
        >
            <Modal.Dialog>
                <Modal.Header closeButton>
                    <Modal.Title>Modal title</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Modal body text goes here.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary">Close</Button>
                    <Button variant="primary">Save changes</Button>
                </Modal.Footer>
            </Modal.Dialog>
        </div>
    );
}

export default ModalExplain;